import store from "@/store";

/**
 * Whether the marketing landing page at / should be shown.
 * When false, navigation to Home should redirect to Login before the Home view mounts.
 */
export async function isLandingPageEnabled() {
  try {
    const res = await store.dispatch("GET_SYSTEM_CONFIG");
    if (res?.data?.status === "success" && res.data?.data) {
      return res.data.data.landing_page_enabled !== false;
    }
  } catch {
    // Network/API failure: allow landing so the site stays usable
  }
  return true;
}
